/** @format */

import uuid from 'uuid';
import React, { useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next/hooks';
import { useStoreActions, useStoreState } from 'easy-peasy';

import ItemsPicker from './ItemsPicker';
import Background from '../Background';
import LegPicker from './LegPicker';

import 'react-phone-input-2/lib/high-res.css';

function TravelSearch(props) {
    const [t] = useTranslation('translation');
    const data = useStoreState((state) => state.travelSearch);
    const service = useStoreActions((actions) => actions.travelsSelect);

    function isValidSelection() {
        if (data.selectedItems.length > 0) return true;
        return false;
    }

    useEffect(() => {
        service.reset();
    });

    if (data.error !== null) {
        debugger;
        return <Redirect to={{ pathname: '/Error' }} />;
    }

    return (
        <div>
            <section>
                <Background />
            </section>
            <section>
                <h1>{t('where')}</h1>
                <LegPicker />
                <div className='verticalSpace6' />
                {/* <div className='warning-message'>
                    Bilbooking fra og med 22.06.2026 for Florabassenget er
                    stengt inntil videre. Det vil sannsynligvis gå et par uker
                    før det åpnes opp for bestilling igjen.
                </div> */}
                <h2>{t('whoWillTravel')}</h2>
                <div style={{ fontSize: '10pt', textAlign: 'center' }}>
                    {t('lengthDescription')}
                </div>
                <div className='verticalSpace12' />
                <ItemsPicker />
                <div className='verticalSpace36' />
                <Link
                    to={'/TravelsSelect/' + uuid.v4()}
                    className={
                        data.fromStop !== null &&
                        (data.toStop !== null) & (data.totalItemsCount > 0) &&
                        isValidSelection()
                            ? 'btn_default'
                            : 'btn_default disabled'
                    }
                >
                    {t('findTrips')}
                </Link>
            </section>
        </div>
    );
}

export default TravelSearch;
